import router from '../router.js'
import { Loading,Message,Notification,MessageBox } from 'element-ui';

let appTool = {
    // for store
    store: {
        // https://www.cnblogs.com/xmoomoo/p/5757464.html
        _keyPrefix: 'sysale-robot$',
        setItem(key, value){
            localStorage.setItem(this._keyPrefix + key, JSON.stringify(value));
        },
        getItem(key){
            let val = localStorage.getItem(this._keyPrefix + key);
            return val == null ? val : JSON.parse(val);
        },
        removeItem(key){
            localStorage.removeItem(this._keyPrefix + key);
        },
        clear(){
            let keys = []
            for (let i = 0; i < localStorage.length; i++) {
                let key = localStorage.key(i);
                if (key.startsWith(this._keyPrefix)) {
                    keys.push(key);
                }
            }
            // 删除
            keys.forEach((val, idx)=> localStorage.removeItem(val))
        }
    },
    // for element ui
    eui: {
        // loading
        // --Vue实例中的方法 this.$loading(options)
        // --Loading.service(options)返回单例对象
        loading(text = '', options = {}){
            this.loading_obj = Loading.service({...options, text: text || ''});
        },
        myloading(text = '', options = {}){
            this.loading_obj = Loading.service({...options, text: text || '', customClass: 'myloading'});
        },
        loading_close(){
            this.loading_obj && this.loading_obj.close();
        },
        // msg
        // --Vue实例中的方法 this.$message(options)
        // --Message(options)
        msg(text){
            Message({
                showClose: true,
                message: text || ''
            });
        },
        msg_success(text){
            Message({
                showClose: true,
                message: text || '',
                type: 'success'
            });
        },
        msg_error(text){
            Message({
                showClose: true,
                message: text || '',
                type: 'error'
            });
        },
        msg_closeAll(){
            Message.closeAll();
        },
        // notify
        // --Vue实例中的方法 this.$notify(options)
        // --Notification(options)
        notify(title, msg){
            Notification({
                title: title || '',
                message: msg || ''
            });
        },
        notify_success(title, msg){
            Notification({
                title: title || '',
                message: msg || '',
                type: 'success'
            });
        },
        notify_error(title, msg){
            Notification({
                title: title || '',
                message: msg || '',
                type: 'error'
            });
        },
        notify_closeAll(){
            Notification.closeAll();
        },
        // alert
        // --Vue实例中的方法 $msgbox, $alert, $confirm 和 $prompt
        // --MessageBox, MessageBox.alert, MessageBox.confirm 和 MessageBox.prompt
        _parseBtn(btn){
            let text = null, fn = null;
            if (typeof btn == 'string') {
                text = btn
            }
            else if (typeof btn == 'function') {
                fn = btn
            }
            else if (btn instanceof Array) {
                if (typeof btn[0] == 'string') text = btn[0]
                if (typeof btn[1] == 'function') fn = btn[1]
            }
            return {text: text, fn: fn}
        },
        alert(title, msg, okButton, closeFn){
            this._alert(title, msg, okButton, closeFn)
        },
        alert_success(title, msg, okButton, closeFn){
            this._alert(title, msg, okButton, closeFn, 'success')
        },
        alert_error(title, msg, okButton, closeFn){
            this._alert(title, msg, okButton, closeFn, 'error')
        },
        _alert(title, msg, okButton, closeFn, type){
            let _okBtn = this._parseBtn(okButton);
            MessageBox.alert(msg || '', title || '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: _okBtn.text || '确定',
                callback: action => {
                    if (action == 'confirm') {
                        typeof _okBtn.fn == 'function' && _okBtn.fn()
                    }
                    else if (action == 'cancel') {
                        typeof closeFn == 'function' && closeFn()
                    }
                },
                type: type || null
            })
        },
        confirm(title, msg, okButton, cancelCloseButton){
            this._confirm(title, msg, okButton, cancelCloseButton);
        },
        confirm_success(title, msg, okButton, cancelCloseButton){
            this._confirm(title, msg, okButton, cancelCloseButton, 'success');
        },
        confirm_error(title, msg, okButton, cancelCloseButton){
            this._confirm(title, msg, okButton, cancelCloseButton, 'error');
        },
        _confirm(title, msg, okButton, cancelCloseButton, type){
            let _okBtn = this._parseBtn(okButton);
            let _ccBtn = this._parseBtn(cancelCloseButton);
            MessageBox.confirm(msg || '', title || '确认信息', {
                    dangerouslyUseHTMLString: true,
                    distinguishCancelAndClose: true,
                    confirmButtonText: _okBtn.text || '确定',
                    cancelButtonText: _ccBtn.text || '取消',
                    type: type || null
                })
                .then(() => {
                    typeof _okBtn.fn == 'function' && _okBtn.fn()
                })
                .catch(action => {
                    typeof _ccBtn.fn == 'function' && _ccBtn.fn(action)
                });
        }
    },
    // for 登录
    isLogin(){
        return this.getLoginUserId() ? true : false
    },
    getLoginUserInfo(){
        /**
         --格式
         {
             id:'',
             account:'',
             name:'',
             loginTime: 1532343352414, // 登录时间
             expire: 1,               // 有效期（天）
             data:{ ...登录成功返回的data }
         }
         */
        let user = this.store.getItem('user');

        if (!user) return null;

        // 判断是否超过登录有效期
        let diff = Math.floor((new Date().getTime() - user.loginTime) / (1000 * 60 * 60 * 24)) // 已登录天数

        if (!user.loginTime || !user.expire || isNaN(diff) || diff > user.expire) {
            this.setUser(null);
            return null
        }

        // ret
        //console.log('已登录' + diff + '天（有效期' + user.expire + '天）')
        return user
    },
    getLoginUserId(){
        let userInfo = this.getLoginUserInfo();
        return userInfo ? userInfo.id : null
    },
    setUser(user){
        if (user)
            this.store.setItem('user', user)
        else
            this.store.removeItem('user')
    },
    // for 工具
    api(rUrl){
        rUrl = rUrl || '';
        let tmp = rUrl.toLowerCase();

        if (tmp.startsWith('http://') || tmp.startsWith('https://') || tmp.startsWith('//')) {
            return rUrl
        }
        else {
            return process.env.API_ROOT + rUrl
        }
    },
    apiWithToken(rUrl){
        let url = this.api(rUrl);
        if(this.isLogin()){
            let user = this.getLoginUserInfo()
            url += url.indexOf('?')>0 ? '&token=' : '?token=';
            url += user.data.token;
        }
        return url;
    },
    to(val){
        router.push(val)
    }
}

appTool.install = (Vue) => {
    Vue.prototype.xAppTool = appTool
    Vue.prototype.xStore = appTool.store
    Vue.prototype.xEui = appTool.eui
    Vue.prototype.xApi = appTool.api
    Vue.prototype.xTo = function (val) {
        this.$router.push(val)
    }
}

export default appTool;



// WEBPACK FOOTER //
// ./src/common/appTool.js